import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import DateRange from "../../components/DateRange/DateRange";
import Select from "react-select";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation, useNavigate } from "react-router-dom";
import { Search_icon, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../components/StaticData";
import { toast } from "react-toastify";

const PropertyLiveApproveList = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname?.replace("/", "");
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    owner: "",
    search: paginationData?.[path]?.search ?? "",
    search_device: "",
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
    cities: [],
  });
  const [PropertiesList, setPropertiesList] = useState([]);
  const [arr, setArr] = useState([]);
  const [popup, setPopup] = useState(false);

  const getList = async (pageNumber = 1) => {
    const { city, from, owner, search, to, search_device } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 7);
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    if (search_device) {
      payload.append("search_device", search_device);
    }
    const res = await post(
      URLS.PROPERTIES_LIST + "?page=" + pageNumber,
      payload,
    );
    console.log("overall properties", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setPropertiesList(res?.data);
    }
  };

  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, ...item };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    getOwnerList();
    getCities();
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.city,
    selectedFilter.owner,
    selectedFilter.search,
    page,
    selectedFilter.search_device,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const handleStatus = async (action, data) => {
    let { id, owner, category, document_verified } = data ?? {};
    // console.log("data--->", data);
    // return;

    if (document_verified !== 1 && action === "approve") {
      toast.error("Document is not verified. Please verify it to proceed.");
      return;
    }

    let payload = { action: action, property_id: id };

    let res = await post(URLS.PROPERTY_LIVE_APPROVE_DECLINE, payload);
    if (res?.status === "success") {
      let { verification_status, status } = res?.data ?? {};
      toast.success(res?.message);
      if (verification_status === 5) {
        navigate("/properties-rejected");
      }
      if (status === 2) {
        navigate("/property-details", {
          state: {
            id: id,
            owner: owner,
            category_id: category,
          },
        });
      }
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Registered Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: " Property",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="center text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.code}</p>
            </div>
          );
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.owner_code}</p>
            </div>
          );
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Mobile Number",
        accessor: "owner_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },

      {
        Header: "Type",
        accessor: "category_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "area_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Requested By",
        accessor: "requested_by_type",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Document Status",
        accessor: "document_verified",
        Cell: ({ value, row }) => {
          return (
            <p style={{ color: value === 1 ? "#22C55E" : "#F59E0B" }}>
              {value === 1 ? "Verified" : "Pending"}
            </p>
          );
        },
      },
      {
        Header: "Tuto seen by Owner",
        accessor: "owner_video_watched",
        Cell: ({ value, row }) => {
          return <p>{value === "Watched" ? "Yes" : "No"}</p>;
        },
      },
      {
        Header: "Tuto seen by Recp",
        accessor: "",
        Cell: ({ _, row }) => {
          return (
            <p
              onClick={() => {
                setArr(row.original.receptionist_video_details);
                setPopup(true);
              }}
              style={{
                color: "#000",
                textDecorationLine: "underline",
                textDecorationColor: "#ae55f5",
                cursor: "pointer",
                margin: 0,
              }}
            >
              {`${row.original.receptionist_video_watched_count} / ${row.original.total_receptionist_count}`}
            </p>
          );
        },
      },
      {
        Header: "Approve live",
        accessor: "",
        Cell: ({ value, row }) => {
          let disable = !row?.original?.live_approval;

          console.log("disable", disable);
          return (
            <div className="d-flex gap-3">
              <button
                className="deactive-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
                disabled={disable}
                style={{ opacity: disable ? 0.4 : 1 }}
                onClick={() => handleStatus("reject", row?.original)}
              >
                Decline
              </button>
              <button
                className="active-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
                disabled={disable}
                style={{ opacity: disable ? 0.4 : 1 }}
                onClick={() => handleStatus("approve", row?.original)}
              >
                Approve
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                className="cust-btn "
                onClick={() => {
                  navigate("/property-live-details", {
                    state: {
                      id: row.original?.id,
                      owner: row.original?.owner,
                      owner_name: row.original?.owner_name,
                      property_name: row.original?.name,
                      category_id: row.original?.category,
                      owner_code: row.original?.owner_code,
                    },
                  });
                }}
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-EDIT-MMC") ? [...d, action] : d;
  }, [page]);

  return (
    <div>
      <Topbar header={"Properties"} subHead={"Live Approval"} />
      <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
      </div>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        <Select
          className="location-search"
          options={optionsList?.owners}
          isClearable
          onChange={(e) => {
            handleChangeFilter("owner", e);
          }}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
          value={selectedFilter?.owner}
          placeholder={"Owner"}
        />
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={PropertiesList}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb mb-1">
              <p className="f4 ms-2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 mt-4">
                Receptionist List
              </p>
              <p
                className="f4 ms-2 fs-xs-10 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 pointer"
                onClick={() => {
                  setArr([]);
                  setPopup(false);
                }}
              >
                X
              </p>
            </div>

            <div className="d-flex ac-jb ">
              <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 primary">
                Receptionist Name
              </p>
              <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 primary">
                ID
              </p>
            </div>

            {arr.length === 0 && (
              <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 ">
                No data
              </p>
            )}

            {arr.map(({ id, name, code }) => {
              return (
                <div key={id} className="d-flex ac-jb ">
                  <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 ">
                    {name}
                  </p>
                  <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 ">
                    {code}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyLiveApproveList;
